/**
 * TAG TOKENS
 * Source: 🎨 Figma — components-rentals export
 *
 * Custom additions are marked with "Custom" comments below.
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createTagTokens(s: SemanticTokens) {
  return {
  // ──── Figma tokens ────

  /** Base spacing for tags */
  base: {
    paddingX: s.layout.gap.sm,  // --tag-base-padding-x: var(--spacing-8)
    paddingY: s.layout.gap.sm,  // --tag-base-padding-y: var(--spacing-8)
    gap: s.layout.gap.sm,       // --tag-base-gap: var(--spacing-8)
    radius: s.radius.sm,        // --tag-base-radius: var(--radius-4)
    fontSize: s.typography.fontSize.xs,       // --tag-base-font-size
    fontWeight: s.typography.fontWeight.bold,  // --tag-base-font-weight
    fontFamily: s.typography.fontFamily.base,  // --tag-base-font-family
    height: '1.5rem',                         // --tag-base-height
    iconSize: s.iconSizes.base,               // --tag-base-icon-size
    lineHeight: s.typography.lineHeight.base,  // --tag-base-line-height
  },
  emphasis: {
    fontSize: s.typography.fontSize.base,      // --tag-emphasis-font-size
    lineHeight: s.typography.lineHeight.xl,    // --tag-emphasis-line-height
    fontWeight: s.typography.fontWeight.semibold
  },
  /** Brand/solid tag */
  brand: {
    fg: s.text.primary,                      // --tag-brand-solid-fg: var(--text-primary)
    bg: s.interactive.primary.subtle,        // --tag-brand-solid-bg: var(--color-rentals-50)
  },
  /** Status tags */
  status: {
    success: {
      fg: s.states.success.fg,               // --tag-status-success-fg: var(--states-success-fg)
      bg: s.states.success.bg,               // --tag-status-success-bg: var(--states-success-bg)
    },
    danger: {
      fg: s.states.danger.fg,                // --tag-status-error-fg: var(--states-danger-fg)
      bg: s.states.danger.bg,                // --tag-status-error-bg: var(--states-danger-bg)
    },
    warning: {
      fg: s.states.warning.fg,               // --tag-status-warning-fg: var(--states-warning-fg)
      bg: s.states.warning.bg,               // --tag-status-warning-bg: var(--states-warning-bg)
    },
    neutralInfo: {
      fg: s.states.info.fg,                  // --tag-status-neutral-info-fg: var(--states-info-fg)
      bg: s.states.info.bg,                  // --tag-status-neutral-info-bg: var(--states-info-bg)
    },
  },

  // ──── Custom tokens (not in Figma) ────

  /** Secondary tag (neutral) */
  secondary: {
    fg: s.text.secondary,                    // --tag-secondary-fg: var(--text-secondary)
    bg: s.surface.canvas,                    // --tag-secondary-bg: var(--surface-canvas)
  },
  };
}
export const tagTokens = createTagTokens(SEMANTIC);